var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"append-icon":"mdi-search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.searchLocal),callback:function ($$v) {_vm.searchLocal=$$v},expression:"searchLocal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }